@value item-spacing: 12px;

.list-selection {
    position: relative;
    height: 100%;
    flex: 0 0 280px;
    overflow-y: auto;
}

.list-label {
    margin-top: 32px;
    color: var(--grey-dk);
    font-size: var(--font-normal);
}

.list-item:not(:last-child),
.list-item > *:not(:last-child) {
    margin-bottom: item-spacing;
}
